var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.818 52C193.523 43.3409 186.739 36.5227 178.136 34.2045C162.545 30 100 30 100 30C100 30 37.4545 30 21.8636 34.2045C13.2614 36.5227 6.47727 43.3409 4.18182 52C0 67.7045 0 100.455 0 100.455C0 100.455 0 133.205 4.18182 148.909C6.47727 157.568 13.2614 164.386 21.8636 166.705C37.4545 170.909 100 170.909 100 170.909C100 170.909 162.545 170.909 178.136 166.705C186.739 164.386 193.523 157.568 195.818 148.909C200 133.205 200 100.455 200 100.455C200 100.455 200 67.7045 195.818 52ZM79.5455 130.193V70.7159L131.818 100.455L79.5455 130.193Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube_logo.f4c527c205ad65f1bda94e2b99b75abe.svg";
export { ForwardRef as ReactComponent };